import { Chip, Theme, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Agency, AgencyCategory, AgencyAbbr, AgencyId, AreaCode, RegionCode, AgencyIds } from "../../../reducers/states/agency";
import { getWspLabel } from "../../../reducers/states/agency/wsp";
import { useAgency } from "../../../hooks/agencies";

const useStyles = makeStyles((theme: Theme) => ({
  chipWsp: {
    backgroundColor: theme.agency.WSP,
    color: "white",
  },
  chipKcm: {
    backgroundColor: theme.agency.KCM,
    color: "white",
  },
  chipFire: {
    backgroundColor: theme.category.Fire,
    color: "white",
  },
  chipLawenforcement: {
    backgroundColor: theme.category.LawEnforcement,
    color: "white",
  },
  chipNeutral: {
    backgroundColor: theme.agency.Neutral,
    color: "black",
  },
  chipClosed: {
    backgroundColor: theme.marker.ClosedDispatchEventIFD,
    color: "white",
  },
  listItem: {
    flex: "1 1 55%",
  },
  removeButton: {
    color: theme.agency.SFD,
    padding: "3px",
    "margin-left": "10px",
  },
}));

interface AgencyChipProps {
  agencyId?: AgencyId; // todo: jcavner: Updates to make this required ?
  agency: AgencyAbbr;
  area?: AreaCode;
  region?: RegionCode;
  isClosed?: boolean;
}

export const AgencyChip = (props: AgencyChipProps) => {
  const agency = useAgency(props.agency);
  const classes = useStyles();

  const getClassName = (agency: Agency) => {
    switch (agency.id) {
      case AgencyIds.WSP:
        return classes.chipWsp;
      case AgencyIds.KingCountyMetro:
        return classes.chipKcm;
    }

    switch (agency.category) {
      case AgencyCategory.Fire:
        return classes.chipFire;
      case AgencyCategory.LawEnforcement:
        return classes.chipLawenforcement;
    }

    return classes.chipNeutral;
  }

  if (!agency) {
    // todo: jcavner: this doesn't look good. Should update it.
    return <div>{props.agency}</div>;
  } else {
    const tooltip = agency.id === AgencyIds.WSP ? `${agency.name}, ${(getWspLabel(props.area) as string)}` : agency.name;
    const className = agency ? getClassName(agency) : classes.chipNeutral;

    return (
      <Tooltip title={tooltip}>
        <Chip label={agency.abbreviation} className={props.isClosed ? classes.chipClosed : className} sx={{ minWidth: "62px" }} />
      </Tooltip>
    )
  }
};
